<template>
  <!-- เมนูกระบวนงาน — แก้รายการเมนูที่ adminProcessMenus.js (manpower) -->
  <AdminProcessNav v-bind="menu" />
</template>

<script>
import AdminProcessNav from "./AdminProcessNav.vue";
import { ADMIN_MENUS } from "./adminProcessMenus";

export default {
  name: "HRvecManpowerBar",
  components: { AdminProcessNav },
  data() {
    return { menu: ADMIN_MENUS.manpower };
  }
};
</script>
